/* eslint-disable */
export const maxLifetime = 0

export default [
[ 0, 100000 ],
[ 1, 78102 ],
[ 2, 74380 ],
[ 3, 72847 ],
[ 4, 71882 ],
[ 5, 71133 ],
[ 10, 68985 ],
[ 15, 67385 ],
[ 20, 64923 ],
[ 25, 61731 ],
[ 30, 58612 ],
[ 35, 55666 ],
[ 40, 52629 ],
[ 45, 49387 ],
[ 50, 45754 ],
[ 55, 41636 ],
[ 60, 36486 ],
[ 65, 30296 ],
[ 70, 22990 ],
[ 75, 15509 ],
[ 80, 8659 ],
[ 85, 0 ],
[ 90, 0 ],
[ 95, 0 ],
[ 100, 0 ],
[ 105, 0 ],
[ 110, 0 ]
]
